import React from 'react';
import { useAuth } from '../contexts/AuthContext';
import LoadingOverlayWithProgress from './LoadingOverlayWithProgress';

const AppWrapper = ({ children }) => {
  const { isPreloadingData } = useAuth();

  return (
    <>
      {children}
      <LoadingOverlayWithProgress 
        isLoading={isPreloadingData} 
        message="Loading..."
      />
    </>
  );
};

export default AppWrapper;
